import { computeAnnualVolumeM3 } from '../../../../../../utils/consumptionCalculations.js';

/**
 * Catégories de gisement (eaux grises collectables) — décision produit : seules douche et
 * lave-linge sont pré-cochées par défaut (eau la moins contaminée). Les robinets/lavabos
 * (catégorie "Hygiène") peuvent être ajoutés manuellement via "+ Ajouter une source" si
 * l'utilisateur le souhaite, mais ne sont pas détectés automatiquement.
 */
export const SOURCE_GROUPS = [
  {
    id: 'shower',
    name: 'Douche',
    matches: (equipment) => equipment?.type_equipment === 'shower',
  },
  {
    id: 'washer',
    name: 'Lave-linge',
    matches: (equipment) => equipment?.type_equipment === 'machine' && equipment?.technical_data?.type_machine === 'washing_machine',
  },
];

/**
 * Catégories de débouchés (usages tolérant une eau non potable) — chasses d'eau, lavage des
 * sols, arrosage extérieur, conformément à la description fonctionnelle du module.
 */
export const TARGET_GROUPS = [
  {
    id: 'wc',
    name: "Chasses d'eau (WC / urinoirs)",
    matches: (equipment) => equipment?.type_equipment === 'wc' || equipment?.type_equipment === 'urinal',
  },
  {
    id: 'menage',
    name: 'Lavage des sols',
    // "Ménage des locaux" (entretien_nettoyage--menage, fusion des ménages santé et
    // tourisme/bureau) — "Ménage" reste un repli pour les usages pas encore
    // recatégorisés (usage_subcategory_id absent).
    matches: (equipment, usage) => usage?.usage_subcategory_id === 'entretien_nettoyage--menage' || usage?.type_usage === 'Ménage',
  },
  {
    id: 'arrosage',
    name: 'Arrosage extérieur',
    // cf. auditUsageImport.js : "Espaces verts" est le libellé actuel, "Arrosage" un
    // alias de migration conservé en repli.
    matches: (equipment, usage) => usage?.usage_category_id === 'espaces_verts' || usage?.type_usage === 'Arrosage',
  },
];

/**
 * Détecte, dans les équipements/usages réels de l'audit, les items correspondant aux groupes
 * fournis — une ligne par usage réel matché (pas une ligne agrégée par catégorie comme dans le
 * module pluie), pour permettre de décocher des points précis dans une catégorie.
 * @returns {Object[]} { id, usageId, categoryId, categoryName, name, volume, enabled, fromAudit }
 */
export const detectGreywaterItems = (equipments, usages, groups) => {
  const equipmentById = new Map(equipments.map(e => [e._id, e]));
  const items = [];

  groups.forEach(group => {
    usages.forEach(usage => {
      const equipment = equipmentById.get(usage._id_equipement);
      if (!group.matches(equipment, usage)) return;

      const room = usage.name_room && usage.name_room !== 'No data' ? usage.name_room : null;
      const section = usage.name_section && usage.name_section !== 'No data' ? usage.name_section : null;
      const locationLabel = [section, room].filter(Boolean).join(' / ');

      items.push({
        id: `${group.id}-${usage._id}`,
        usageId: usage._id,
        categoryId: group.id,
        categoryName: group.name,
        name: locationLabel ? `${group.name} — ${locationLabel}` : group.name,
        volume: Math.round(computeAnnualVolumeM3(equipment, usage) * 100) / 100,
        enabled: true,
        fromAudit: true,
      });
    });
  });

  return items;
};
